import '@/assets/styles/components/checkbox.styles.scss';
import React from 'react';
import { CheckboxProps } from './checkbox.types';
import clsx from 'clsx';

export const Checkbox: React.FC<CheckboxProps> = ({ label, variant = 'default', size = 'medium', checked = false, disabled = false, onChange, className, ...props }) => {
	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		if (!disabled && onChange) {
			onChange(e);
		}
	};

	return (
		<label className={clsx(`checkbox-container ${variant}`, checked && 'checked', disabled && 'disabled', className)}>
			<input
				type="checkbox"
				checked={checked}
				disabled={disabled}
				onChange={handleChange}
				{...props}
			/>
			<div className="checkbox-mark" />
			{label && <span className={`checkbox-text ${size}`}>{label}</span>}
		</label>
	);
};
